var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "fas fa-file-upload" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("import")) + "\n\t")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-input", {
              attrs: {
                "float-label": _vm.$t("title"),
                error: _vm.$v.title.$error
              },
              on: { input: _vm.$v.title.$touch },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                options: [
                  { label: _vm.$t("users"), value: 1 },
                  { label: _vm.$t("companies_and_branches"), value: 2 }
                ],
                "float-label": _vm.$t("import_type"),
                error: _vm.$v.import_type.$error
              },
              model: {
                value: _vm.import_type,
                callback: function($$v) {
                  _vm.import_type = $$v
                },
                expression: "import_type"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm q-mt-sm" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("file")))
                ]),
                _c("uploader", {
                  attrs: {
                    content_type: "xlsx",
                    multiple: false,
                    error: _vm.$v.file_url.$error,
                    disable: _vm.id !== 0
                  },
                  on: { fileUploaded: _vm.fileUploaded }
                }),
                _vm.file_url
                  ? _c(
                      "p",
                      { staticClass: "q-mt-md file-url" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fas fa-check", color: "positive" }
                        }),
                        _c(
                          "a",
                          { attrs: { href: _vm.file_url, target: "_blank" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$truncateLink(_vm.file_url))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_imports" })
                }
              }
            })
          ],
          1
        ),
        _vm.status != 2
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    disabled: _vm.disabled,
                    label: _vm.$t("save_and_validate"),
                    icon: "far fa-save"
                  },
                  on: {
                    click: function($event) {
                      return _vm.saveData()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.id != 0 && this.status == 3 && this.import == true
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("import")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "green",
                    label: _vm.$t("import"),
                    icon: "fas fa-check"
                  },
                  on: {
                    click: function($event) {
                      return _vm.importData()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.status == 2
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    disabled: _vm.disabled,
                    label: _vm.$t("process"),
                    icon: "far fa-save"
                  },
                  on: {
                    click: function($event) {
                      return _vm.processImport()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.validated
        ? _c("div", { staticClass: "q-pt-md" }, [
            _c("div", { staticClass: "q-pa-md q-pt-md bg-green-2" }, [
              _vm.users.length > 0
                ? _c("p", { staticClass: "q-mb-none" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$t("total_rows_found_for_users")) +
                        ": " +
                        _vm._s(_vm.users.length) +
                        "\n\t\t\t"
                    )
                  ])
                : _vm._e(),
              _vm.companies.length > 0
                ? _c("p", { staticClass: "q-mb-none" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$t("total_rows_found_for_companies")) +
                        ": " +
                        _vm._s(_vm.companies.length) +
                        "\n\t\t\t"
                    )
                  ])
                : _vm._e(),
              _vm.branches.length > 0
                ? _c("p", { staticClass: "q-mb-none" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$t("total_rows_found_for_branches")) +
                        ": " +
                        _vm._s(_vm.branches.length) +
                        "\n\t\t\t"
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _c(
        "q-dialog",
        {
          attrs: { cancel: false },
          on: {
            ok: function($event) {
              return _vm.hideError()
            }
          },
          model: {
            value: _vm.show_message,
            callback: function($$v) {
              _vm.show_message = $$v
            },
            expression: "show_message"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("attention")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "wait_the_import_is_being_processed_you_will_be_notified_at_the_end_of_the_process"
                )
              )
            )
          ])
        ]
      ),
      _vm.table_users
        ? _c(
            "div",
            [
              _c("h4", { staticClass: "q-my-md" }, [
                _vm._v(_vm._s(_vm.$t("all_users_errors")))
              ]),
              _c("q-table", {
                attrs: {
                  data: _vm.users_errors,
                  columns: _vm.columns,
                  filter: _vm.filter,
                  "row-key": "line"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          { attrs: { props: props } },
                          _vm._l(props.cols, function(col) {
                            return _c(
                              "q-th",
                              { key: col.name, attrs: { props: props } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(_vm.$t(col.label)) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          }),
                          1
                        )
                      }
                    },
                    {
                      key: "body",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-td",
                              { key: "line", attrs: { props: props } },
                              [_vm._v(_vm._s(props.row.line))]
                            ),
                            _c(
                              "q-td",
                              { key: "full_name", attrs: { props: props } },
                              [_vm._v(_vm._s(props.row.full_name))]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "status_messages",
                                attrs: { props: props }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    props.row.status_messages
                                      .map(function(e) {
                                        return _vm.$t(e)
                                      })
                                      .join(", ")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "error_count",
                                attrs: { props: props, "auto-width": "" }
                              },
                              [
                                _c(
                                  "q-chip",
                                  {
                                    staticClass: "full-width",
                                    attrs: {
                                      small: "",
                                      icon: _vm.getIconStatus(
                                        props.row.error_count
                                      ),
                                      color: _vm.getColorStatus(
                                        props.row.error_count
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.getStatus(props.row.error_count)
                                          )
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }
                    }
                  ],
                  null,
                  false,
                  3083761422
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm.table_companies
        ? _c(
            "div",
            [
              _c("h4", { staticClass: "q-my-md" }, [
                _vm._v(_vm._s(_vm.$t("all_headquarters_errors")))
              ]),
              _c("q-table", {
                attrs: {
                  data: _vm.companies_errors,
                  columns: _vm.columns,
                  filter: _vm.filter,
                  "row-key": "line"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          { attrs: { props: props } },
                          _vm._l(props.cols, function(col) {
                            return _c(
                              "q-th",
                              { key: col.name, attrs: { props: props } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(_vm.$t(col.label)) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          }),
                          1
                        )
                      }
                    },
                    {
                      key: "body",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-td",
                              { key: "line", attrs: { props: props } },
                              [_vm._v(_vm._s(props.row.line))]
                            ),
                            _c(
                              "q-td",
                              { key: "full_name", attrs: { props: props } },
                              [_vm._v(_vm._s(props.row.company_name))]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "status_messages",
                                attrs: { props: props }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    props.row.status_messages
                                      .map(function(e) {
                                        return _vm.$t(e)
                                      })
                                      .join(", ")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "error_count",
                                attrs: { props: props, "auto-width": "" }
                              },
                              [
                                _c(
                                  "q-chip",
                                  {
                                    staticClass: "full-width",
                                    attrs: {
                                      small: "",
                                      icon: _vm.getIconStatus(
                                        props.row.error_count
                                      ),
                                      color: _vm.getColorStatus(
                                        props.row.error_count
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.getStatus(props.row.error_count)
                                          )
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }
                    }
                  ],
                  null,
                  false,
                  574518458
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm.table_branches
        ? _c(
            "div",
            [
              _c("h4", { staticClass: "q-my-md" }, [
                _vm._v(_vm._s(_vm.$t("all_store_errors")))
              ]),
              _c("q-table", {
                attrs: {
                  data: _vm.branches_errors,
                  columns: _vm.columns,
                  filter: _vm.filter,
                  "row-key": "line"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          { attrs: { props: props } },
                          _vm._l(props.cols, function(col) {
                            return _c(
                              "q-th",
                              { key: col.name, attrs: { props: props } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(_vm.$t(col.label)) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          }),
                          1
                        )
                      }
                    },
                    {
                      key: "body",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-td",
                              { key: "line", attrs: { props: props } },
                              [_vm._v(_vm._s(props.row.line))]
                            ),
                            _c(
                              "q-td",
                              { key: "full_name", attrs: { props: props } },
                              [_vm._v(_vm._s(props.row.branch_name))]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "status_messages",
                                attrs: { props: props }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    props.row.status_messages
                                      .map(function(e) {
                                        return _vm.$t(e)
                                      })
                                      .join(", ")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "error_count",
                                attrs: { props: props, "auto-width": "" }
                              },
                              [
                                _c(
                                  "q-chip",
                                  {
                                    staticClass: "full-width",
                                    attrs: {
                                      small: "",
                                      icon: _vm.getIconStatus(
                                        props.row.error_count
                                      ),
                                      color: _vm.getColorStatus(
                                        props.row.error_count
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.getStatus(props.row.error_count)
                                          )
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }
                    }
                  ],
                  null,
                  false,
                  3381841353
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm.logs.length
        ? _c(
            "div",
            [
              _c("h4", { staticClass: "q-my-md" }, [
                _vm._v(_vm._s(_vm.$t("logs")))
              ]),
              _c("q-table", {
                attrs: {
                  data: _vm.logs,
                  columns: _vm.columns_logs,
                  filter: _vm.filter,
                  "row-key": "line",
                  pagination: _vm.logs_pagination
                },
                on: {
                  request: _vm.requestLog,
                  "update:pagination": function($event) {
                    _vm.logs_pagination = $event
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          { attrs: { props: props } },
                          _vm._l(props.cols, function(col) {
                            return _c(
                              "q-th",
                              { key: col.name, attrs: { props: props } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(_vm.$t(col.label)) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          }),
                          1
                        )
                      }
                    },
                    {
                      key: "body",
                      fn: function(props) {
                        return _c(
                          "q-tr",
                          { attrs: { props: props } },
                          [
                            _c("q-td", { key: "id", attrs: { props: props } }, [
                              _vm._v(_vm._s(props.row.id))
                            ]),
                            _c(
                              "q-td",
                              { key: "content", attrs: { props: props } },
                              [_vm._v(_vm._s(props.row.content))]
                            ),
                            _c(
                              "q-td",
                              { key: "import_type", attrs: { props: props } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(_vm.getImportType(_vm.import_type))
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            ),
                            _c(
                              "q-td",
                              {
                                key: "status",
                                attrs: { props: props, "auto-width": "" }
                              },
                              [
                                _c(
                                  "q-chip",
                                  {
                                    staticClass: "full-width",
                                    attrs: {
                                      small: "",
                                      icon: _vm.getIconImportStatus(
                                        props.row.status
                                      ),
                                      color: _vm.getColorImportStatus(
                                        props.row.status
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.getImportStatus(
                                              props.row.status
                                            )
                                          )
                                        ) +
                                        "\n\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }
                    }
                  ],
                  null,
                  false,
                  1067708061
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }